export const questionsAverageRatingCardConstants = {
  SURVEY_QUESTIONS: "Survey Questions",
  GROUP_AVERAGE: "Group Average",
  STORE_AVERAGE: "Store Average",
  PREVIOUS: "Previous",
  DAYS: "days",
  QUESTION: "Question",
  SINCE_LAST: "since last",
  SEE_AVERAGES: "See Averages",
  QUESTION_TEST_ID_PREFIX: "Question - ",
  NO_RATING: "-",
  IN_STORE: "In-Store",
  ARCHIVED_QUESTIONS: "Archived Questions",
};

export const multiSelectLabels = {
  TOTAL_SELECTED: "Total Selected: ",
  SELECTED: "Selected: ",
};

export const SYMBOLS = {
  PERCENTAGE: "%",
};

export const WHITESPACE = {
  SPACE: " ",
};

/** Result of `typeof` for an undefined value (e.g. SSR `typeof window` checks). */
export const TYPEOF_UNDEFINED = "undefined";

/** DOM / window event names for addEventListener / removeEventListener. */
export const WINDOW_EVENTS = {
  RESIZE: "resize",
  CLICK: "click",
  SCROLL: "scroll",
  KEYDOWN: "keydown",
  MOUSEDOWN: "mousedown",
};

export const PERCENTAGE_FORMAT_CONSTANTS = {
  MULTIPLIER: 100,
  DECIMAL_PLACES: 2,
};

/** DataTable / TanStack `desc` flag (boolean), not API "asc"/"desc" strings. */
export const SORT_DIRECTION = {
  ASCENDING: false,
  DESCENDING: true,
};

export const averageCardTitleConstants = {
  AVERAGE_TRANSACTION_RATING: "Average Transaction Rating",
  AVERAGE_SENTIMENT_RATING: "Average Sentiment Rating",
};

export const columnsWithDarkGrayBackground = [
  "emailsCount",
  "emailDelivered",
  "emailOpened",
  "emailClicked",
  "smsCount",
  "smsDeliveredCount",
];
export const columnsWithLightGrayBackground = [
  "campaignTitle",
  "restaurantTitle",
  "totalCampaignOrders",
  "totalRevenue",
];

export const COLORS = {
  WHITE: "#fff",
  BLACK: "black",
  GRAY: "gray",
  GREY: "#F4F4F4",
  DARK_GREY: "#d4d4d4",
  LIGHT_GREY: "#f8f9fa",
  MEDIUM_GREY: "#eee",
  LIGHTER_GREY: "#F5F5F5",
  SILVER_GREY: "#ced4da",
  ASH_GREY: "#cccccc",
  /** Neutral border / muted UI grey. */
  MUTED_GREY: "#999999",
  SCARLET: "#dc3545",
  DARK_GREEN: "#027b68",
  ROYAL_BLUE: "#234FCD",
  BRIGHT_GREEN: "#35B841",
  GOLDEN_YELLOW: "#EFC416",
  /** Focus / active teal used by react-select borders. */
  TEAL: "#108474",
  LIGHT_GREEN: "#0b0f36",
  DARK_TEAL: "#174b44",
  DARK_NAVY: "#262b40",
  GOLD: "#F1A900",
  AMBER: "#f0a900",
  BLACK_SHADOW: "rgba(0, 0, 0, 0.23)",
};

export const FONT_FAMILY = {
  ARIAL: "arial",
};

export const phoneConstants = {
  COUNTRY_CODE: "1",
  COUNTRY_DISPLAY: "+1",
  LENGTH: 10,
  PATTERN: /\d{10}$/,
  INVALID_MESSAGE: "Phone Number is not valid",
  FORMAT_HINT: "Format: +1XXXXXXXXXX",
};

export const KEYBOARD_KEYS = {
  BACKSPACE: "Backspace",
  SPACE: " ",
  TAB: "Tab", // or 9 for keyCode
  ENTER: "Enter", // or 13 for keyCode
  ESCAPE: "Escape", // or 27 for keyCode
  UP_ARROW: "ArrowUp", // or 38 for keyCode
  DOWN_ARROW: "ArrowDown", // or 40 for keyCode
  LEFT_ARROW: "ArrowLeft", // or 37 for keyCode
  RIGHT_ARROW: "ArrowRight", // or 39 for keyCode
};

export const CURSOR = {
  GRAB: "grab",
  DEFAULT: "default",
};

export const BUTTON_TEXT = {
  ADD: "Add",
  NEW: "New",
  BACK: "Back",
  CANCEL: "Cancel",
  SAVE: "Save",
  DISCARD: "Discard",
  CONFIRM: "Confirm",
  UPDATE: "Update",
  CLOSE: "Close",
  EDIT: "Edit",
  GENERATE: "Generate",
  GENERATING: "Generating...",
  REGENERATE: "Regenerate",
  REACTIVATE: "Reactivate",
  YES: "Yes",
  NO: "No",
};

export const STYLES = {
  NONE: "none",
  AUTO: "auto",
  D_NONE: "d-none",
  IS_INVALID: "is-invalid",
  IS_VALID: "is-valid",
  BORDER_DANGER: "border border-danger",
  DASHED: "1px dashed black",
  TEXT_SUCCESS: "text-success",
  TEXT_DARK: "text-dark",
  TEXT_GRAY: "text-gray",
  DISABLE_ICON: "disabled-icon",
  TEXT_DANGER: "text-danger",
  ACTIVE: "active",
  ICON_SPACING: "me-1",
  MENU_ICON_SPACING: "pe-2",
  GREEN_COLOR: "green-color",
  TEXT_SECONDARY: "text-secondary",
};

export const fileFormat = {
  IMG_TYPES: ".svg, .jpg, .jpeg, .jfif, .png",
  BASE_64_IMAGE_TYPES: ["image/svg+xml", "image/jpeg", "image/png"],
  ATTACHMENT_TYPE: ".pdf, .csv,.docx, .svg, .jpg, .jpeg, .jfif, .png",
};

export const performanceScreensConstants = {
  GUEST_SENTIMENTS: "GuestSentiments",
  GUEST_TRANSACTION: "GuestTransaction",
  TRANSACTION: "Transaction",
  SENTIMENT: "Sentiment",
};

export const inputFieldTypes = {
  PASSWORD: "password",
  TEXT: "text",
  CHECKBOX: "checkbox",
};

/** Shared array index / length values for reusable empty & first-item checks. */
export const FIRST_ARRAY_INDEX = 0;
export const EMPTY_ARRAY_LENGTH = 0;
export const SINGLE_ARRAY_LENGTH = 1;

/** Shared infinite-scroll / list query defaults (stores, managers, brand groups). */
export const LIST_PAGE_SIZE = 15;
export const LIST_SEARCH_DEBOUNCE_MS = 1000;

/** Font Awesome `size` prop values used across shared/UI components. */
export const FONT_AWESOME_SIZE = {
  SM: "sm",
  LG: "lg",
  XL: "xl",
};

/** Shared "All…" filter / select placeholders and option labels. */
export const FILTER_LABEL = {
  ALL: "All",
  ALL_STORES: "All Stores",
  ALL_GROUPS: "All Groups",
  ALL_STATES: "All States",
  ALL_BRANDS: "All Brands",
  ALL_PROFILE_TYPES: "All Profile Types",
  ALL_PLATFORM_TYPES: "All Platform Types",
};

export const sideBarContainerTopConstants = {
  SUPER_ADMIN_DASHBOARD_LINK: /^\/stores\/dashboard\/\d+$/,
  PROFILE_IMAGE_SIZE: 30,
  COMPACT_NAME_BREADCRUMB_COUNT: 3,
  USER_PROFILE_EVENT_KEY: "user-profile",
  SIGN_OUT_EVENT_KEY: "signOut-event-key",
};

export const NAVIGATION_DELAYS_MS = {
  INBOX_UNAVAILABLE_REDIRECT: 8000,
  FR_STORE_PROFILE_REQUEST: 2000,
};

export const PASSWORD_MIN_LENGTH = 8;

export const PASSWORD_LENGTH_ERROR =
  "Password must be at least 8 characters long.";

/** Shared password strength regex used by login / reset / account-setup forms. */
export const PASSWORD_VALIDATION_PATTERN =
  /^(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*()_+\-=[\]{};':"\\|,.<>/?]).{8,}$/;

export const passwordValidationMessages = {
  NUMBER: "Password must contain at least a number.",
  CAPITAL: "Password must contain at least a capital letter.",
  SPECIAL_CHAR:
    "Password must contain a special character (@, $, !, &, etc).",
  MATCH: "Password and confirm password matched.",
  NOT_VALID: "Password is not valid",
};

export const DEFAULT_PASSWORD_CHECK_VALIDATION = {
  checkCapLetter: false,
  checkNumber: false,
  checkSpecialChar: false,
  checkLength: false,
  checkEquality: false,
};

export const AVERAGE_RATING_RESPONSE_TYPE = {
  GET_STORE_AVERAGE_RATING_RESPONSES: 1,
  GET_GROUPS_AVERAGE_RATING_RESPONSES: 2,
  GET_GROUP_AVERAGE_RATING_RESPONSES: 3,
  GET_MANAGER_AVERAGE_RATING_RESPONSES: 4,
  GET_INDIVIDUAL_STORE_AVERAGE_RATING_RESPONSE: 5,
};

export const GET_RESPONSE_TYPE = {
  GET_RESTAURANT_RESPONSES: 1,
  GET_GROUP_USER_RESPONSES: 2,
  GET_GROUP_RESPONSES: 3,
  GET_MANAGER_USER_RESPONSES: 4,
};

export const AI_REPLY_THREAD_ERROR_PATTERNS = [
  "add messages to thread_",
  "already has an active run run_",
];

export const conversionReportColors = [
  "#005bb0",
  "#0686fd",
  "#17b2f4",
  "#3fc9f8",
  "#28A745",
  "#FFC107",
  "#DC3545",
  "#6338f0",
  "#005bb0",
  "#0686fd",
  "#17b2f4",
  "#3fc9f8",
];

export const inboxReportColors = [
  "#800080",
  "#005bb0",
  "#0686fd",
  "#17b2f4",
  "#28A745",
  "#FFC107",
  "#DC3545",
];

export const DEFAULT_VALUE = 0;

export const RATING_DEFAULT_VALUES = {
  ZERO_CHANGE: DEFAULT_VALUE.toFixed(PERCENTAGE_FORMAT_CONSTANTS.DECIMAL_PLACES),
  FULL_CHANGE: PERCENTAGE_FORMAT_CONSTANTS.MULTIPLIER,
};
